import FormattedDateTime from 'I18n/components/FormattedDateTime';
import FormattedReactMessage from 'I18n/components/FormattedReactMessage';
import Small from 'UIComponents/elements/Small';
import UIFlex from 'UIComponents/layout/UIFlex';
import UITooltip from 'UIComponents/tooltip/UITooltip';
import InlineFeedback from 'ai-components-ui-library/components/feedback/InlineFeedback';
import CopilotPreviewHeader from './CopilotPreviewHeader';
import { getCopyButtonText } from './utils/CopyButton';
import SimpleMessageSection from '../../conversational/SimpleMessageSection';
import LoadingDot from './LoadingDot';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
import { Fragment as _Fragment } from "react/jsx-runtime";
const CopilotPreviewInner = ({
  children,
  onRefresh,
  onPositiveFeedback,
  onNegativeFeedback,
  previewTitle,
  numHoursTilSummaryStale,
  response,
  loading,
  usageTracker
}) => {
  const copyMessage = getCopyButtonText(response);
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [/*#__PURE__*/_jsx(UIFlex, {
      className: "m-bottom-3",
      align: "center",
      children: /*#__PURE__*/_jsx(CopilotPreviewHeader, {
        numHoursTilSummaryStale: numHoursTilSummaryStale,
        timestamp: response && response.timestamp,
        onRefresh: onRefresh,
        previewTitle: previewTitle
      })
    }), /*#__PURE__*/_jsxs(Small, {
      tagName: "div",
      className: "m-bottom-4",
      children: [response && response.sections && response.sections.length > 0 && response.sections.map(section => /*#__PURE__*/_jsx(SimpleMessageSection, {
        section: section
      }, section.id)), loading && /*#__PURE__*/_jsx(LoadingDot, {})]
    }), children, /*#__PURE__*/_jsxs(UIFlex, {
      align: "center",
      justify: "between",
      children: [response && response.timestamp && /*#__PURE__*/_jsx(UITooltip, {
        title: /*#__PURE__*/_jsx(FormattedReactMessage, {
          message: "aiAddonCopilotPreview.components.copilotPreview.timestamp.tooltip",
          options: {
            timestamp: /*#__PURE__*/_jsx(FormattedDateTime, {
              value: response.timestamp,
              format: "LLLL"
            })
          }
        }),
        children: /*#__PURE__*/_jsx(Small, {
          style: {
            fontWeight: '300'
          },
          use: "help",
          children: /*#__PURE__*/_jsx(FormattedDateTime, {
            value: response.timestamp,
            format: "ll"
          })
        })
      }), response && response.messageId && /*#__PURE__*/_jsx("div", {
        children: /*#__PURE__*/_jsx(InlineFeedback, {
          copyMessage: copyMessage,
          messageId: response.messageId,
          onPositiveFeedback: onPositiveFeedback,
          onNegativeFeedback: onNegativeFeedback,
          usageTracker: usageTracker
        })
      })]
    })]
  });
};
export default CopilotPreviewInner;